import * as c from "react";
import { jsx as v, jsxs as j, Fragment as H } from "react/jsx-runtime";
import "react-dom";
function _(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function M(...e) {
  return (t) => {
    let n = !1;
    const s = e.map((r) => {
      const o = _(r, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let r = 0; r < s.length; r++) {
          const o = s[r];
          typeof o == "function" ? o() : _(e[r], null);
        }
      };
  };
}
function P(...e) {
  return c.useCallback(M(...e), e);
}
// @__NO_SIDE_EFFECTS__
function V(e) {
  const t = /* @__PURE__ */ q(e), n = c.forwardRef((s, r) => {
    const { children: o, ...a } = s, i = c.Children.toArray(o), u = i.find(K);
    if (u) {
      const l = u.props.children, f = i.map((d) => d === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...a, ref: r, children: c.isValidElement(l) ? c.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ v(t, { ...a, ref: r, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function q(e) {
  const t = c.forwardRef((n, s) => {
    const { children: r, ...o } = n;
    if (c.isValidElement(r)) {
      const a = Z(r), i = X(o, r.props);
      return r.type !== c.Fragment && (i.ref = s ? M(s, a) : a), c.cloneElement(r, i);
    }
    return c.Children.count(r) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var G = Symbol("radix.slottable");
function K(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === G;
}
function X(e, t) {
  const n = { ...t };
  for (const s in t) {
    const r = e[s], o = t[s];
    /^on[A-Z]/.test(s) ? r && o ? n[s] = (...i) => {
      const u = o(...i);
      return r(...i), u;
    } : r && (n[s] = r) : s === "style" ? n[s] = { ...r, ...o } : s === "className" && (n[s] = [r, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Z(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var J = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], w = J.reduce((e, t) => {
  const n = /* @__PURE__ */ V(`Primitive.${t}`), s = c.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, u = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(u, { ...i, ref: o });
  });
  return s.displayName = `Primitive.${t}`, { ...e, [t]: s };
}, {});
function Q(e, t = []) {
  let n = [];
  function s(o, a) {
    const i = c.createContext(a), u = n.length;
    n = [...n, a];
    const l = (d) => {
      const { scope: p, children: m, ...h } = d, y = p?.[e]?.[u] || i, g = c.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ v(y.Provider, { value: g, children: m });
    };
    l.displayName = o + "Provider";
    function f(d, p) {
      const m = p?.[e]?.[u] || i, h = c.useContext(m);
      if (h) return h;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return [l, f];
  }
  const r = () => {
    const o = n.map((a) => c.createContext(a));
    return function(i) {
      const u = i?.[e] || o;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: u } }),
        [i, u]
      );
    };
  };
  return r.scopeName = e, [s, Y(r, ...t)];
}
function Y(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const s = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(o) {
      const a = s.reduce((i, { useScope: u, scopeName: l }) => {
        const d = u(o)[`__scope${l}`];
        return { ...i, ...d };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function O(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e?.(r), n === !1 || !r.defaultPrevented)
      return t?.(r);
  };
}
var k = globalThis?.document ? c.useLayoutEffect : () => {
}, ee = c[" useInsertionEffect ".trim().toString()] || k;
function te({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: s
}) {
  const [r, o, a] = ne({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, u = i ? e : r;
  {
    const f = c.useRef(e !== void 0);
    c.useEffect(() => {
      const d = f.current;
      d !== i && console.warn(
        `${s} is changing from ${d ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = i;
    }, [i, s]);
  }
  const l = c.useCallback(
    (f) => {
      if (i) {
        const d = re(f) ? f(e) : f;
        d !== e && a.current?.(d);
      } else
        o(f);
    },
    [i, e, o, a]
  );
  return [u, l];
}
function ne({
  defaultProp: e,
  onChange: t
}) {
  const [n, s] = c.useState(e), r = c.useRef(n), o = c.useRef(t);
  return ee(() => {
    o.current = t;
  }, [t]), c.useEffect(() => {
    r.current !== n && (o.current?.(n), r.current = n);
  }, [n, r]), [n, s, o];
}
function re(e) {
  return typeof e == "function";
}
function oe(e, t) {
  return c.useReducer((n, s) => t[n][s] ?? n, e);
}
var T = (e) => {
  const { present: t, children: n } = e, s = se(t), r = typeof n == "function" ? n({ present: s.isPresent }) : c.Children.only(n), o = P(s.ref, ce(r));
  return typeof n == "function" || s.isPresent ? c.cloneElement(r, { ref: o }) : null;
};
T.displayName = "Presence";
function se(e) {
  const [t, n] = c.useState(), s = c.useRef(null), r = c.useRef(e), o = c.useRef("none"), a = e ? "mounted" : "unmounted", [i, u] = oe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const l = E(s.current);
    o.current = i === "mounted" ? l : "none";
  }, [i]), k(() => {
    const l = s.current, f = r.current;
    if (f !== e) {
      const p = o.current, m = E(l);
      e ? u("MOUNT") : m === "none" || l?.display === "none" ? u("UNMOUNT") : u(f && p !== m ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, u]), k(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, d = (m) => {
        const y = E(s.current).includes(CSS.escape(m.animationName));
        if (m.target === t && y && (u("ANIMATION_END"), !r.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, p = (m) => {
        m.target === t && (o.current = E(s.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: c.useCallback((l) => {
      s.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function E(e) {
  return e?.animationName || "none";
}
function ce(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ie(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function ue(e) {
  const [t, n] = c.useState(void 0);
  return k(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const s = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const o = r[0];
        let a, i;
        if ("borderBoxSize" in o) {
          const u = o.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          a = l.inlineSize, i = l.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        n({ width: a, height: i });
      });
      return s.observe(e, { box: "border-box" }), () => s.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var N = "Checkbox", [ae, Ce] = Q(N), [le, A] = ae(N);
function de(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: s,
    defaultChecked: r,
    disabled: o,
    form: a,
    name: i,
    onCheckedChange: u,
    required: l,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: d
  } = e, [p, m] = te({
    prop: n,
    defaultProp: r ?? !1,
    onChange: u,
    caller: N
  }), [h, y] = c.useState(null), [g, b] = c.useState(null), C = c.useRef(!1), R = h ? !!a || !!h.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), x = {
    checked: p,
    disabled: o,
    setChecked: m,
    control: h,
    setControl: y,
    name: i,
    form: a,
    value: f,
    hasConsumerStoppedPropagationRef: C,
    required: l,
    defaultChecked: S(r) ? !1 : r,
    isFormControl: R,
    bubbleInput: g,
    setBubbleInput: b
  };
  return /* @__PURE__ */ v(
    le,
    {
      scope: t,
      ...x,
      children: me(d) ? d(x) : s
    }
  );
}
var D = "CheckboxTrigger", U = c.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...s }, r) => {
    const {
      control: o,
      value: a,
      disabled: i,
      checked: u,
      required: l,
      setControl: f,
      setChecked: d,
      hasConsumerStoppedPropagationRef: p,
      isFormControl: m,
      bubbleInput: h
    } = A(D, e), y = P(r, f), g = c.useRef(u);
    return c.useEffect(() => {
      const b = o?.form;
      if (b) {
        const C = () => d(g.current);
        return b.addEventListener("reset", C), () => b.removeEventListener("reset", C);
      }
    }, [o, d]), /* @__PURE__ */ v(
      w.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": S(u) ? "mixed" : u,
        "aria-required": l,
        "data-state": W(u),
        "data-disabled": i ? "" : void 0,
        disabled: i,
        value: a,
        ...s,
        ref: y,
        onKeyDown: O(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: O(n, (b) => {
          d((C) => S(C) ? !0 : !C), h && m && (p.current = b.isPropagationStopped(), p.current || b.stopPropagation());
        })
      }
    );
  }
);
U.displayName = D;
var fe = c.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: s,
      checked: r,
      defaultChecked: o,
      required: a,
      disabled: i,
      value: u,
      onCheckedChange: l,
      form: f,
      ...d
    } = e;
    return /* @__PURE__ */ v(
      de,
      {
        __scopeCheckbox: n,
        checked: r,
        defaultChecked: o,
        disabled: i,
        required: a,
        onCheckedChange: l,
        name: s,
        form: f,
        value: u,
        internal_do_not_use_render: ({ isFormControl: p }) => /* @__PURE__ */ j(H, { children: [
          /* @__PURE__ */ v(
            U,
            {
              ...d,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          p && /* @__PURE__ */ v(
            B,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
fe.displayName = N;
var L = "CheckboxIndicator", pe = c.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: s, ...r } = e, o = A(L, n);
    return /* @__PURE__ */ v(
      T,
      {
        present: s || S(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ v(
          w.span,
          {
            "data-state": W(o.checked),
            "data-disabled": o.disabled ? "" : void 0,
            ...r,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
pe.displayName = L;
var $ = "CheckboxBubbleInput", B = c.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: s,
      hasConsumerStoppedPropagationRef: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: u,
      name: l,
      value: f,
      form: d,
      bubbleInput: p,
      setBubbleInput: m
    } = A($, e), h = P(n, m), y = ie(o), g = ue(s);
    c.useEffect(() => {
      const C = p;
      if (!C) return;
      const R = window.HTMLInputElement.prototype, I = Object.getOwnPropertyDescriptor(
        R,
        "checked"
      ).set, z = !r.current;
      if (y !== o && I) {
        const F = new Event("click", { bubbles: z });
        C.indeterminate = S(o), I.call(C, S(o) ? !1 : o), C.dispatchEvent(F);
      }
    }, [p, y, o, r]);
    const b = c.useRef(S(o) ? !1 : o);
    return /* @__PURE__ */ v(
      w.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? b.current,
        required: i,
        disabled: u,
        name: l,
        value: f,
        form: d,
        ...t,
        tabIndex: -1,
        ref: h,
        style: {
          ...t.style,
          ...g,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
B.displayName = $;
function me(e) {
  return typeof e == "function";
}
function S(e) {
  return e === "indeterminate";
}
function W(e) {
  return S(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
export {
  fe as C,
  pe as a
};
